import { render, staticRenderFns } from "./PacketAgeCheck.vue?vue&type=template&id=513ab33f&scoped=true"
import script from "./PacketAgeCheck.vue?vue&type=script&lang=js"
export * from "./PacketAgeCheck.vue?vue&type=script&lang=js"
import style0 from "./PacketAgeCheck.vue?vue&type=style&index=0&id=513ab33f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513ab33f",
  null
  
)

export default component.exports